import { render, staticRenderFns } from "./UserInfoPart1Form.vue?vue&type=template&id=4585e9f6"
import script from "./UserInfoPart1Form.vue?vue&type=script&lang=js"
export * from "./UserInfoPart1Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports